import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface QuickAction {
  title: string;
  description: string;
  icon: string;
  href: string;
  color: string;
}

const QuickActions = () => {
  const actions: QuickAction[] = [
    {
      title: 'Compare Prices',
      description: 'See dealership vs independent shop pricing for your repair',
      icon: 'ChartBarIcon',
      href: '/price-compare',
      color: 'bg-primary'
    },
    {
      title: 'Find OEM Parts',
      description: 'AI-powered parts finder with eBay marketplace integration',
      icon: 'MagnifyingGlassIcon',
      href: '/oem-parts-finder',
      color: 'bg-accent'
    },
    {
      title: 'DIY Repair Library',
      description: 'Follow step-by-step video guides to fix simple problems yourself',
      icon: 'WrenchIcon',
      href: '/diy',
      color: 'bg-secondary'
    }
  ];

  return (
    <section className="bg-muted py-16 sm:py-24">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-text-primary mb-4">
            More Ways to Save
          </h2>
          <p className="font-body text-base sm:text-lg text-text-secondary max-w-2xl mx-auto">
            Explore additional tools to help you make informed decisions about your vehicle maintenance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {actions.map((action, index) => (
            <Link
              key={index}
              href={action.href}
              className="group bg-card rounded-xl p-8 shadow-elevation-sm transition-smooth hover:shadow-elevation-lg hover:-translate-y-1"
            >
              <div className={`flex items-center justify-center w-16 h-16 rounded-xl ${action.color} mb-6 group-hover:scale-110 transition-smooth`}>
                <Icon name={action.icon as any} size={32} className="text-white" />
              </div>

              <h3 className="font-heading text-xl font-semibold text-text-primary mb-3 group-hover:text-primary transition-smooth">
                {action.title}
              </h3>

              <p className="font-body text-sm text-text-secondary leading-relaxed mb-4">
                {action.description}
              </p>

              <div className="flex items-center space-x-2 text-primary group-hover:text-primary/80 transition-smooth">
                <span className="font-body text-sm font-medium">Learn More</span>
                <Icon name="ArrowRightIcon" size={16} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;